<template>
    <div class="row">
        <div v-if="isLoading" class="col-12 text-center p-5">
            <p>Loading cars...</p>
        </div>
        <div v-else-if="getError" class="col-12 text-center p-5">
            <p class="text-danger">Error loading cars: {{ getError }}</p>
        </div>
        <div v-for="car in getAllCars" :key="car.refnum" class="pt-4 col-md-6 col-lg-4 h-100">
            <div class="pt-2 d-flex justify-content-center">
            <div v-on:click="gotoCar(car.refnum)" class="car-header-avatar" :style="`background-image: url(${imageBaseURL}img/cars/${car.refnum}/car01.jpg)`"></div>
            </div>
            <!-- <img style="width:140px;height:140px;overflow: hidden;" class="rounded-circle img img-responsive" src="https://lh3.googleusercontent.com/proxy/9NFIFIE3E3Me0NkOMSuEbdd6zpQbnpPIL30sD_0f_nQ-T5Pi_76SlazdVHumTpx9cck63knMH-1G8ERfNuJXDzjNCOwkof8FS_1gd-A43wxRUvRU8McC9gW5FA" alt=""> -->
            <!-- <img class="bd-placeholder-img rounded-circle" width="140" height="140" src="https://lh3.googleusercontent.com/proxy/9NFIFIE3E3Me0NkOMSuEbdd6zpQbnpPIL30sD_0f_nQ-T5Pi_76SlazdVHumTpx9cck63knMH-1G8ERfNuJXDzjNCOwkof8FS_1gd-A43wxRUvRU8McC9gW5FA" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 140x140"><title>Placeholder</title><rect width="100%" height="100%" fill="#777"/><text x="50%" y="50%" fill="#777" dy=".3em">140x140</text></img> -->
            <!-- <h2 class="pt-2">{{car.name}}</h2> -->
            <div v-if="car.soldStaus">
            <h2 :v-if="car.name" class="jumbotron-heading pt-3">{{ car.name }}</h2>
            <h5 :v-if="car.name" style="color:red;" class="jumbotron-heading text-red">SOLD</h5>
            </div>
            <div v-else>
            <h2 :v-if="car.name" class="jumbotron-heading pt-3">{{ car.name }}</h2>
            </div>
            <p v-html="car.smalldesc"></p>
            <div class="btn btn-secondary" v-on:click="gotoCar(car.refnum)" :data-id="car.refnum" role="button" > View details &raquo;</div>
        </div><!-- /.col-lg-4 -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CarList',
  props: {
    msg: String
  },
  computed: {
    ...mapGetters(['getAllCars', 'isLoading', 'getError'])
  },
  methods: {
    gotoCar (e) {
      console.log(e)
      this.$store.commit('setSelCar', e)
      this.$router.push({ path: `/car/${e}` })
    }
  },
  async mounted () {
    // Fetch cars from API
    console.log('CarList -- mounted, fetching cars from API')
    await this.$store.dispatch('fetchAllCars', { sold: false })
  }
  //,
  // async created () {
  // // GET request using fetch with async/await
  //   const response = await fetch('./cars.json')
  //   const data = await response.json()
  //   console.log('data from file ', data)
  // }
}
</script>

<style scoped>

.car-header-avatar{
    width: 210px;
    height: 140px;
    /* -webkit-border-radius: 140px; */
    -webkit-background-clip: padding-box;
    -moz-border-radius: 140px;
    -moz-background-clip: padding;
    border-radius: 5px;
    background-clip: padding-box;
    margin: 7px 0 0 5px;
    /* float: left; */
    background-size: cover;
    background-position: center center;
}

/* CUSTOMIZE THE CAROUSEL
-------------------------------------------------- */

/* Carousel base class */
.carousel {
  margin-bottom: 4rem;
}
/* Since positioning the image, we need to help out the caption */
.carousel-caption {
  bottom: 3rem;
  z-index: 10;
}

/* Declare heights because of positioning of img element */
.carousel-item {
  height: 32rem;
}
/* .carousel-item > img {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  height: 32rem;
} */

/* MARKETING CONTENT
-------------------------------------------------- */

/* Center align the text within the three columns below the carousel */
.marketing .col-lg-4 {
  margin-bottom: 1.5rem;
  text-align: center;
}
.marketing h2 {
  font-weight: 400;
}
.marketing .col-lg-4 p {
  margin-right: .75rem;
  margin-left: .75rem;
}
</style>
